import { useCallback } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { SearchInput } from '@/components/ui/search-input.tsx'
import { Tooltip } from '@/components/ui/tooltip'
import { debounce } from '@/utils/helpers'

interface RecentSpendersHeaderButtonsProps {
  onNewListPress: () => void
  setFilter: (filter: string) => void
}

export const RecentSpendersHeaderButtons: React.FC<
  RecentSpendersHeaderButtonsProps
> = ({ onNewListPress, setFilter }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputChange = useCallback(debounce(setFilter, 500), [setFilter])

  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Search"
        onInputChange={handleInputChange}
      />
      <Tooltip
        asChild
        content="Create a new Recent Spend List"
      >
        <span>
          <Button
            className="gap-1"
            onClick={onNewListPress}
            testId="create-list"
          >
            <PlusIcon />
            <span className="inline">Create List</span>
          </Button>
        </span>
      </Tooltip>
    </div>
  )
}
